// 物品商品名称格式化
export function getGoodsShowName(name, type, priceName) {
    let str = name
    // 按物品定价
    if (type == 2) {
        str += `(${priceName})`
    }
 return str
}